import React from 'react';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import { useCurrentCapAmountByDomains } from './queries';

export default function CurrentCapAmountByDomains({ id, domains }) {
  const { data } = useCurrentCapAmountByDomains(id, domains);

  return (
    <div>
      <FormLabel htmlFor='currentSegmentAmount' sx={{ display: 'block', mb: 0.5 }}>
        Current Segment Amount
      </FormLabel>
      <TextField id='currentSegmentAmount' disabled type='number' value={data ?? ''} />
    </div>
  );
}
